/**
 * タブバー中央の撮影ボタン（C-17）→ 経費の明細作成への受け渡し。
 * ファイル選択（<input capture>）はユーザー操作の中で済ませ、選ばれた File をここに置いて画面遷移する。
 * 遷移先（/expense/new?capture=1）が takePendingCapture() で受け取る。
 */
let pending: File[] | null = null;

export function setPendingCapture(files: File[]): void {
  pending = files.length ? files : null;
}

export function takePendingCapture(): File[] | null {
  const f = pending;
  pending = null;
  return f;
}

export function hasPendingCapture(): boolean {
  return pending !== null;
}
